import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Clickable, Surface, Text } from '../../atoms';
import { useTheme } from '@emotion/react';
import { IconContext } from '@talismn/web-icons/utils';
import { LayoutGroup, motion } from 'framer-motion';
import { createContext, useId } from 'react';
const SegmentedButtonContext = createContext({ value: undefined, onChange: () => { } });
const ButtonSegment = ({ value, leadingIcon, children, ...passProps }) => {
    const theme = useTheme();
    return (_jsx(SegmentedButtonContext.Consumer, { children: ({ value: selectedValue, onChange }) => (_jsxs(Text.Body, { as: Clickable, ...passProps, css: [
                {
                    position: 'relative',
                    padding: '0.7em 0.85em',
                },
                // This is to prevent a bug with Chrome, specifically in the swap/transport component
                selectedValue === value && {
                    '*': {
                        color: `color-mix(in srgb, ${theme.color.onPrimary}, transparent 30%)`,
                    },
                },
                // Should be doing this instead
                // selectedValue === value && {
                //   color: theme.color.onPrimary,
                // },
            ], onClick: () => onChange?.(value), children: [selectedValue === value && (_jsx(motion.div, { layoutId: "highlight", css: {
                        position: 'absolute',
                        inset: 0,
                        borderRadius: theme.shape.full,
                        backgroundColor: theme.color.primaryContainer,
                    } })), _jsxs("div", { css: { position: 'relative', display: 'flex', alignItems: 'center', gap: '0.25em' }, children: [leadingIcon && (_jsx("div", { css: { display: 'contents' }, children: _jsx(IconContext.Provider, { value: { size: '1.125em' }, children: leadingIcon }) })), children] })] })) }));
};
const SegmentedButton = Object.assign((props) => {
    const theme = useTheme();
    return (_jsx(SegmentedButtonContext.Provider, { value: {
            value: props.value,
            // @ts-expect-error
            onChange: props.onChange,
        }, children: _jsx(LayoutGroup, { id: useId(), children: _jsx(Surface, { as: "section", className: props.className, css: { display: 'inline-block', borderRadius: theme.shape.full, padding: '0.4rem' }, children: props.children }) }) }));
}, { ButtonSegment });
export default SegmentedButton;
//# sourceMappingURL=SegmentedButton.js.map